// Generated G layer lookup table
// Contains flattened taxonomy for Songs

export const G_LAYER_LOOKUP = {
  POP: {
    numericCode: '001',
    name: 'Pop',
  },
  'POP.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'POP.GLB': {
    numericCode: '002',
    name: 'Global_Pop',
  },
  'POP.TEN': {
    numericCode: '003',
    name: 'Teen_Pop',
  },
  'POP.DNC': {
    numericCode: '004',
    name: 'Dance_Pop',
  },
  'POP.ELC': {
    numericCode: '005',
    name: 'Electro_Pop',
  },
  'POP.DRM': {
    numericCode: '006',
    name: 'Dream_Pop',
  },
  'POP.IND': {
    numericCode: '007',
    name: 'Indie_Pop',
  },
  'POP.LAT': {
    numericCode: '008',
    name: 'Latin_Pop',
  },
  'POP.SOU': {
    numericCode: '009',
    name: 'Soul_Pop',
  },
  'POP.RCK': {
    numericCode: '010',
    name: 'Pop_Rock',
  },
  'POP.ALT': {
    numericCode: '011',
    name: 'Alt_Pop',
  },
  'POP.TSW': {
    numericCode: '012',
    name: 'Swift_Inspired',
  },
  RCK: {
    numericCode: '002',
    name: 'Rock',
  },
  'RCK.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'RCK.CLS': {
    numericCode: '002',
    name: 'Classic_Rock',
  },
  'RCK.MOD': {
    numericCode: '003',
    name: 'Modern_Rock',
  },
  'RCK.GRG': {
    numericCode: '004',
    name: 'Grunge',
  },
  'RCK.PNK': {
    numericCode: '005',
    name: 'Punk_Rock',
  },
  'RCK.ALR': {
    numericCode: '006',
    name: 'Alternative_Rock',
  },
  'RCK.PRG': {
    numericCode: '007',
    name: 'Progressive_Rock',
  },
  'RCK.PSY': {
    numericCode: '008',
    name: 'Psychedelic_Rock',
  },
  'RCK.FLK': {
    numericCode: '009',
    name: 'Folk_Rock',
  },
  'RCK.ARN': {
    numericCode: '010',
    name: 'Arena_Rock',
  },
  'RCK.GAR': {
    numericCode: '011',
    name: 'Garage_Rock',
  },
  'RCK.BLU': {
    numericCode: '012',
    name: 'Blues_Rock',
  },
  HIP: {
    numericCode: '003',
    name: 'Hip_Hop',
  },
  'HIP.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'HIP.CLS': {
    numericCode: '002',
    name: 'Classic_Hip_Hop',
  },
  'HIP.MOD': {
    numericCode: '003',
    name: 'Modern_Hip_Hop',
  },
  'HIP.TRP': {
    numericCode: '004',
    name: 'Trap',
  },
  'HIP.CLD': {
    numericCode: '005',
    name: 'Cloud_Rap',
  },
  'HIP.DRL': {
    numericCode: '006',
    name: 'Drill',
  },
  'HIP.CON': {
    numericCode: '007',
    name: 'Conscious_Rap',
  },
  'HIP.BBP': {
    numericCode: '008',
    name: 'Boom_Bap',
  },
  'HIP.JZZ': {
    numericCode: '009',
    name: 'Jazz_Rap',
  },
  'HIP.FNK': {
    numericCode: '010',
    name: 'Funk_Rap',
  },
  'HIP.PRT': {
    numericCode: '011',
    name: 'Party_Rap',
  },
  DNC: {
    numericCode: '004',
    name: 'Dance_Electronic',
  },
  'DNC.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'DNC.HSE': {
    numericCode: '002',
    name: 'House',
  },
  'DNC.TEC': {
    numericCode: '003',
    name: 'Techno',
  },
  'DNC.TRN': {
    numericCode: '004',
    name: 'Trance',
  },
  'DNC.DUB': {
    numericCode: '005',
    name: 'Dubstep',
  },
  'DNC.FUT': {
    numericCode: '006',
    name: 'Future_Bass',
  },
  'DNC.TRO': {
    numericCode: '007',
    name: 'Tropical_House',
  },
  'DNC.PRH': {
    numericCode: '008',
    name: 'Progressive_House',
  },
  'DNC.DPH': {
    numericCode: '009',
    name: 'Deep_House',
  },
  'DNC.TCH': {
    numericCode: '010',
    name: 'Tech_House',
  },
  'DNC.EXP': {
    numericCode: '011',
    name: 'Experimental_Electronic',
  },
  DSF: {
    numericCode: '005',
    name: 'Disco_Funk',
  },
  'DSF.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'DSF.DIS': {
    numericCode: '002',
    name: 'Disco',
  },
  'DSF.FNK': {
    numericCode: '003',
    name: 'Funk',
  },
  'DSF.NUD': {
    numericCode: '004',
    name: 'Nu_Disco',
  },
  RNB: {
    numericCode: '006',
    name: 'RnB',
  },
  'RNB.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'RNB.SOU': {
    numericCode: '002',
    name: 'Soul',
  },
  'RNB.MOD': {
    numericCode: '003',
    name: 'Modern',
  },
  'RNB.NEO': {
    numericCode: '004',
    name: 'Neo_Soul',
  },
  'RNB.GOS': {
    numericCode: '005',
    name: 'Gospel',
  },
  'RNB.BLU': {
    numericCode: '006',
    name: 'Blues',
  },
  'RNB.FNK': {
    numericCode: '007',
    name: 'Funk',
  },
  'RNB.JSU': {
    numericCode: '008',
    name: 'Jazz_Soul',
  },
  'RNB.URB': {
    numericCode: '009',
    name: 'Urban',
  },
  'RNB.ALT': {
    numericCode: '010',
    name: 'Alternative',
  },
  'RNB.FSU': {
    numericCode: '011',
    name: 'Future_Soul',
  },
  JZZ: {
    numericCode: '007',
    name: 'Jazz',
  },
  'JZZ.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'JZZ.CON': {
    numericCode: '002',
    name: 'Contemporary_Jazz',
  },
  'JZZ.TRD': {
    numericCode: '003',
    name: 'Traditional_Jazz',
  },
  'JZZ.SMO': {
    numericCode: '004',
    name: 'Smooth_Jazz',
  },
  'JZZ.AVG': {
    numericCode: '005',
    name: 'Avant_Garde_Jazz',
  },
  'JZZ.FUS': {
    numericCode: '006',
    name: 'Jazz_Fusion',
  },
  'JZZ.NSJ': {
    numericCode: '007',
    name: 'Neo_Soul_Jazz',
  },
  'JZZ.LAT': {
    numericCode: '008',
    name: 'Latin_Jazz',
  },
  'JZZ.COO': {
    numericCode: '009',
    name: 'Cool_Jazz',
  },
  'JZZ.FRE': {
    numericCode: '010',
    name: 'Free_Jazz',
  },
  'JZZ.WLD': {
    numericCode: '011',
    name: 'World_Jazz',
  },
  JPO: {
    numericCode: '008',
    name: 'J_Pop',
  },
  'JPO.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'JPO.POP': {
    numericCode: '002',
    name: 'Pop',
  },
  'JPO.RKF': {
    numericCode: '003',
    name: 'Rock_Fusion',
  },
  'JPO.ANI': {
    numericCode: '004',
    name: 'Anime_Music',
  },
  'JPO.ELC': {
    numericCode: '005',
    name: 'Electronic',
  },
  'JPO.KAW': {
    numericCode: '006',
    name: 'Kawaii',
  },
  'JPO.ALT': {
    numericCode: '007',
    name: 'Alternative',
  },
  'JPO.TRD': {
    numericCode: '008',
    name: 'Traditional',
  },
  'JPO.DNC': {
    numericCode: '009',
    name: 'Dance',
  },
  'JPO.RET': {
    numericCode: '010',
    name: 'Retro',
  },
  'JPO.ACO': {
    numericCode: '011',
    name: 'Acoustic',
  },
  BOL: {
    numericCode: '009',
    name: 'Bollywood',
  },
  'BOL.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'BOL.PLB': {
    numericCode: '002',
    name: 'Playback',
  },
  'BOL.PFU': {
    numericCode: '003',
    name: 'Pop_Fusion',
  },
  'BOL.CLS': {
    numericCode: '004',
    name: 'Classical',
  },
  'BOL.DNC': {
    numericCode: '005',
    name: 'Dance',
  },
  'BOL.IFU': {
    numericCode: '006',
    name: 'Indie_Fusion',
  },
  'BOL.ELC': {
    numericCode: '007',
    name: 'Electronic',
  },
  'BOL.FLK': {
    numericCode: '008',
    name: 'Folk',
  },
  'BOL.SFI': {
    numericCode: '009',
    name: 'Sufi',
  },
  'BOL.RMX': {
    numericCode: '010',
    name: 'Remix',
  },
  'BOL.GLB': {
    numericCode: '011',
    name: 'Global',
  },
  LAT: {
    numericCode: '010',
    name: 'Latin',
  },
  'LAT.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'LAT.REG': {
    numericCode: '002',
    name: 'Reggaeton',
  },
  'LAT.POP': {
    numericCode: '003',
    name: 'Pop',
  },
  'LAT.SAL': {
    numericCode: '004',
    name: 'Salsa',
  },
  'LAT.BCH': {
    numericCode: '005',
    name: 'Bachata',
  },
  'LAT.RCK': {
    numericCode: '006',
    name: 'Rock',
  },
  'LAT.TRP': {
    numericCode: '007',
    name: 'Trap',
  },
  'LAT.MER': {
    numericCode: '008',
    name: 'Merengue',
  },
  'LAT.JZZ': {
    numericCode: '009',
    name: 'Jazz',
  },
  'LAT.CUM': {
    numericCode: '010',
    name: 'Cumbia',
  },
  'LAT.FLM': {
    numericCode: '011',
    name: 'Flamenco',
  },
  IND: {
    numericCode: '011',
    name: 'Indie',
  },
  'IND.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'IND.RCK': {
    numericCode: '002',
    name: 'Rock',
  },
  'IND.POP': {
    numericCode: '003',
    name: 'Pop',
  },
  'IND.FLK': {
    numericCode: '004',
    name: 'Folk',
  },
  'IND.ELC': {
    numericCode: '005',
    name: 'Electronic',
  },
  'IND.HIP': {
    numericCode: '006',
    name: 'Hip_Hop',
  },
  'IND.DRM': {
    numericCode: '007',
    name: 'Dream',
  },
  'IND.LOF': {
    numericCode: '008',
    name: 'Lo_Fi',
  },
  'IND.ART': {
    numericCode: '009',
    name: 'Art',
  },
  'IND.PST': {
    numericCode: '010',
    name: 'Post',
  },
  ALT: {
    numericCode: '012',
    name: 'Alternative',
  },
  'ALT.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'ALT.RCK': {
    numericCode: '002',
    name: 'Rock',
  },
  'ALT.POP': {
    numericCode: '003',
    name: 'Pop',
  },
  'ALT.EXP': {
    numericCode: '004',
    name: 'Experimental',
  },
  'ALT.DRK': {
    numericCode: '005',
    name: 'Dark',
  },
  'ALT.MTL': {
    numericCode: '006',
    name: 'Metal',
  },
  'ALT.IND': {
    numericCode: '007',
    name: 'Industrial',
  },
  'ALT.ART': {
    numericCode: '008',
    name: 'Art',
  },
  'ALT.NOI': {
    numericCode: '009',
    name: 'Noise',
  },
  'ALT.PST': {
    numericCode: '010',
    name: 'Post',
  },
  'ALT.SHG': {
    numericCode: '011',
    name: 'Shoegaze',
  },
  WLD: {
    numericCode: '013',
    name: 'World',
  },
  'WLD.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'WLD.FUS': {
    numericCode: '002',
    name: 'Fusion',
  },
  'WLD.AFR': {
    numericCode: '003',
    name: 'African',
  },
  'WLD.IND': {
    numericCode: '004',
    name: 'Indian',
  },
  'WLD.MDE': {
    numericCode: '005',
    name: 'Middle_East',
  },
  'WLD.CEL': {
    numericCode: '006',
    name: 'Celtic',
  },
  'WLD.REG': {
    numericCode: '007',
    name: 'Reggae',
  },
  'WLD.ASN': {
    numericCode: '008',
    name: 'Asian',
  },
  'WLD.BAL': {
    numericCode: '009',
    name: 'Balkan',
  },
  'WLD.MED': {
    numericCode: '010',
    name: 'Mediterranean',
  },
  'WLD.GLB': {
    numericCode: '011',
    name: 'Global',
  },
  RFK: {
    numericCode: '014',
    name: 'Regional_Folk',
  },
  'RFK.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'RFK.TFK': {
    numericCode: '002',
    name: 'Traditional_Folk',
  },
  'RFK.MFK': {
    numericCode: '003',
    name: 'Modern_Folk',
  },
  'RFK.CEL': {
    numericCode: '004',
    name: 'Celtic',
  },
  'RFK.AFR': {
    numericCode: '005',
    name: 'African',
  },
  'RFK.ASN': {
    numericCode: '006',
    name: 'Asian',
  },
  'RFK.LAT': {
    numericCode: '007',
    name: 'Latin_Folk',
  },
  'RFK.MDE': {
    numericCode: '008',
    name: 'Middle_Eastern',
  },
  'RFK.WFU': {
    numericCode: '009',
    name: 'World_Fusion',
  },
  'RFK.AMR': {
    numericCode: '010',
    name: 'Americana',
  },
  'RFK.GLB': {
    numericCode: '011',
    name: 'Global_Folk',
  },
  KPO: {
    numericCode: '015',
    name: 'K_Pop',
  },
  'KPO.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'KPO.IBG': {
    numericCode: '002',
    name: 'Idol_Boy_Group',
  },
  'KPO.IGG': {
    numericCode: '003',
    name: 'Idol_Girl_Group',
  },
  'KPO.SFS': {
    numericCode: '004',
    name: 'Solo_Female_Star',
  },
  'KPO.SMS': {
    numericCode: '005',
    name: 'Solo_Male_Star',
  },
  'KPO.RAP': {
    numericCode: '006',
    name: 'Rapper',
  },
  'KPO.DNL': {
    numericCode: '007',
    name: 'Dance_Leader',
  },
  'KPO.VIS': {
    numericCode: '008',
    name: 'Visual',
  },
  'KPO.VOC': {
    numericCode: '009',
    name: 'Vocalist',
  },
  'KPO.MAK': {
    numericCode: '010',
    name: 'Maknae',
  },
  HYP: {
    numericCode: '016',
    name: 'Hyperpop',
  },
  'HYP.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'HYP.GLT': {
    numericCode: '002',
    name: 'Glitchcore',
  },
  'HYP.SYN': {
    numericCode: '003',
    name: 'Synthpop',
  },
  AFB: {
    numericCode: '017',
    name: 'Afrobeats',
  },
  'AFB.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'AFB.NPO': {
    numericCode: '002',
    name: 'Nigerian_Pop',
  },
  'AFB.GPO': {
    numericCode: '003',
    name: 'Ghanaian_Pop',
  },
  MOD: {
    numericCode: '018',
    name: 'Mood_Based',
  },
  'MOD.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'MOD.HAP': {
    numericCode: '002',
    name: 'Happy',
  },
  'MOD.SAD': {
    numericCode: '003',
    name: 'Sad',
  },
  'MOD.ENE': {
    numericCode: '004',
    name: 'Energetic',
  },
  BLU: {
    numericCode: '019',
    name: 'Blues',
  },
  'BLU.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'BLU.DLT': {
    numericCode: '002',
    name: 'Delta_Blues',
  },
  'BLU.CHG': {
    numericCode: '003',
    name: 'Chicago_Blues',
  },
  CLS: {
    numericCode: '020',
    name: 'Classical',
  },
  'CLS.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'CLS.ORC': {
    numericCode: '002',
    name: 'Orchestral',
  },
  'CLS.CHM': {
    numericCode: '003',
    name: 'Chamber',
  },
};

export const G_SUBCATEGORIES = {
  POP: [
    'POP.BAS',
    'POP.GLB',
    'POP.TEN',
    'POP.DNC',
    'POP.ELC',
    'POP.DRM',
    'POP.IND',
    'POP.LAT',
    'POP.SOU',
    'POP.RCK',
    'POP.ALT',
    'POP.TSW',
  ],
  RCK: [
    'RCK.BAS',
    'RCK.CLS',
    'RCK.MOD',
    'RCK.GRG',
    'RCK.PNK',
    'RCK.ALR',
    'RCK.PRG',
    'RCK.PSY',
    'RCK.FLK',
    'RCK.ARN',
    'RCK.GAR',
    'RCK.BLU',
  ],
  HIP: [
    'HIP.BAS',
    'HIP.CLS',
    'HIP.MOD',
    'HIP.TRP',
    'HIP.CLD',
    'HIP.DRL',
    'HIP.CON',
    'HIP.BBP',
    'HIP.JZZ',
    'HIP.FNK',
    'HIP.PRT',
  ],
  DNC: [
    'DNC.BAS',
    'DNC.HSE',
    'DNC.TEC',
    'DNC.TRN',
    'DNC.DUB',
    'DNC.FUT',
    'DNC.TRO',
    'DNC.PRH',
    'DNC.DPH',
    'DNC.TCH',
    'DNC.EXP',
  ],
  DSF: ['DSF.BAS', 'DSF.DIS', 'DSF.FNK', 'DSF.NUD'],
  RNB: [
    'RNB.BAS',
    'RNB.SOU',
    'RNB.MOD',
    'RNB.NEO',
    'RNB.GOS',
    'RNB.BLU',
    'RNB.FNK',
    'RNB.JSU',
    'RNB.URB',
    'RNB.ALT',
    'RNB.FSU',
  ],
  JZZ: [
    'JZZ.BAS',
    'JZZ.CON',
    'JZZ.TRD',
    'JZZ.SMO',
    'JZZ.AVG',
    'JZZ.FUS',
    'JZZ.NSJ',
    'JZZ.LAT',
    'JZZ.COO',
    'JZZ.FRE',
    'JZZ.WLD',
  ],
  JPO: [
    'JPO.BAS',
    'JPO.POP',
    'JPO.RKF',
    'JPO.ANI',
    'JPO.ELC',
    'JPO.KAW',
    'JPO.ALT',
    'JPO.TRD',
    'JPO.DNC',
    'JPO.RET',
    'JPO.ACO',
  ],
  BOL: [
    'BOL.BAS',
    'BOL.PLB',
    'BOL.PFU',
    'BOL.CLS',
    'BOL.DNC',
    'BOL.IFU',
    'BOL.ELC',
    'BOL.FLK',
    'BOL.SFI',
    'BOL.RMX',
    'BOL.GLB',
  ],
  LAT: [
    'LAT.BAS',
    'LAT.REG',
    'LAT.POP',
    'LAT.SAL',
    'LAT.BCH',
    'LAT.RCK',
    'LAT.TRP',
    'LAT.MER',
    'LAT.JZZ',
    'LAT.CUM',
    'LAT.FLM',
  ],
  IND: [
    'IND.BAS',
    'IND.RCK',
    'IND.POP',
    'IND.FLK',
    'IND.ELC',
    'IND.HIP',
    'IND.DRM',
    'IND.LOF',
    'IND.ART',
    'IND.PST',
  ],
  ALT: [
    'ALT.BAS',
    'ALT.RCK',
    'ALT.POP',
    'ALT.EXP',
    'ALT.DRK',
    'ALT.MTL',
    'ALT.IND',
    'ALT.ART',
    'ALT.NOI',
    'ALT.PST',
    'ALT.SHG',
  ],
  WLD: [
    'WLD.BAS',
    'WLD.FUS',
    'WLD.AFR',
    'WLD.IND',
    'WLD.MDE',
    'WLD.CEL',
    'WLD.REG',
    'WLD.ASN',
    'WLD.BAL',
    'WLD.MED',
    'WLD.GLB',
  ],
  RFK: [
    'RFK.BAS',
    'RFK.TFK',
    'RFK.MFK',
    'RFK.CEL',
    'RFK.AFR',
    'RFK.ASN',
    'RFK.LAT',
    'RFK.MDE',
    'RFK.WFU',
    'RFK.AMR',
    'RFK.GLB',
  ],
  KPO: [
    'KPO.BAS',
    'KPO.IBG',
    'KPO.IGG',
    'KPO.SFS',
    'KPO.SMS',
    'KPO.RAP',
    'KPO.DNL',
    'KPO.VIS',
    'KPO.VOC',
    'KPO.MAK',
  ],
  HYP: ['HYP.BAS', 'HYP.GLT', 'HYP.SYN'],
  AFB: ['AFB.BAS', 'AFB.NPO', 'AFB.GPO'],
  MOD: ['MOD.BAS', 'MOD.HAP', 'MOD.SAD', 'MOD.ENE'],
  BLU: ['BLU.BAS', 'BLU.DLT', 'BLU.CHG'],
  CLS: ['CLS.BAS', 'CLS.ORC', 'CLS.CHM'],
};
